import { render, staticRenderFns } from "./PromoAndExceptionTable.vue?vue&type=template&id=1cca3130"
import script from "./PromoAndExceptionTable.vue?vue&type=script&lang=js"
export * from "./PromoAndExceptionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports